import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TinyMceEditor = _resolveComponent("TinyMceEditor")!

  return (_ctx.editorContent !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TinyMceEditor, {
          modelValue: _ctx.editorContent,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editorContent) = $event)),
          init: _ctx.tinyMceOptions
        }, null, 8 /* PROPS */, ["modelValue", "init"])
      ]))
    : _createCommentVNode("v-if", true)
}